module.exports = __webpack_public_path__ + "static/media/use-back@2x.7851c3eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/use-back@2x.png
// module id = 889
// module chunks = 0